/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_YouInputs */

const en_directory_ai_tools_studio_photo_you = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo 1 · You`)
};

const zh_directory_ai_tools_studio_photo_you = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片 1 · 你`)
};

/**
* | output |
* | --- |
* | "Photo 1 · You" |
*
* @param {Directory_Ai_Tools_Studio_Photo_YouInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_you = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_YouInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_YouInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_you(inputs)
	return zh_directory_ai_tools_studio_photo_you(inputs)
});
export { directory_ai_tools_studio_photo_you as "directory.ai_tools.studio.photo_you" }